import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Nav from "../shared/Nav";
import Footer from "../shared/Footer";
import "../assets/css/variables.css";
import "../assets/css/global.css";
import "../assets/css/pages.css";

export default function NewsAndEvents() {
  const [news, setNews] = useState([]);
  const [events, setEvents] = useState([]);
  const [modal, setModal] = useState(null);

  const [formState, setFormState] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);

  const API = "https://accelia-backend.onrender.com";

  useEffect(() => {
    fetchNews();
    fetchEvents();
  }, []);

  const fetchNews = async () => {
    try {
      const res = await fetch(`${API}/api/news`);
      const data = await res.json();
      setNews(data.news || []);
    } catch (err) {
      console.error("News fetch error:", err);
    }
  };

  const fetchEvents = async () => {
    try {
      const res = await fetch(`${API}/api/events`);
      const data = await res.json();
      setEvents(Array.isArray(data) ? data : data.data || []);
    } catch (err) {
      console.error("Events fetch error:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await fetch(`${API}/api/contacts`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formState),
      });
      setSubmitted(true);
      setFormState({ name: "", email: "", phone: "", message: "" });
      setTimeout(() => setSubmitted(false), 4000);
    } catch (err) {
      console.error("Submit error:", err);
    }
  };

  // Close modal on Escape key
  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape") setModal(null);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  const CAT_COLORS = {
    Research: { bg: "#ede9fe", color: "#7c3aed" },
    "Company News": { bg: "#dbeafe", color: "#1d4ed8" },
    Education: { bg: "#dcfce7", color: "#15803d" },
    Partnership: { bg: "#fef3c7", color: "#b45309" },
    Regulatory: { bg: "#fee2e2", color: "#b91c1c" },
    "Clinical Trial": { bg: "#ccfbf1", color: "#0f766e" },
    General: { bg: "#f1f5f9", color: "#475569" },
  };

  function getCatStyle(cat) {
    return CAT_COLORS[cat] || CAT_COLORS.General;
  }

  return (
    <>
      <Nav />

      <div className="page-wrapper">
        {/* HERO */}
        <div className="page-hero">
          <div className="sec-tag sec-tag--gold">News & Resources</div>
          <h1 className="sec-title sec-title--white">News & Resources</h1>
          <p style={{ color: "rgba(255,255,255,0.6)" }}>
            Stay updated with latest news and events.
          </p>
        </div>

        {/* ───────── NEWS ───────── */}
        <section style={{ padding: "4rem 2.5rem" }}>
          <div className="sec-tag">Latest News</div>
          <h2 className="sec-title">Latest News</h2>

          <div className="news-grid">
            {news.map((n) => (
              <div
                key={n._id}
                className="news-card"
                onClick={() => setModal(n)}
                style={{ cursor: "pointer" }}
              >
                <div className="news-card__img">📰</div>
                <div className="news-card__body">
                  <span className="news-tag">{n.category}</span>
                  <h3>{n.title}</h3>
                  <p
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {n.content || n.description || n.body}
                  </p>
                  <div className="news-card__date">
                    {new Date(n.date).toDateString()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ───────── EVENTS ───────── */}
        <section style={{ padding: "0 2.5rem 4rem" }}>
          <div className="sec-tag">Latest Events</div>
          <h2 className="sec-title">Latest Events</h2>

          <div className="resource-grid">
            {events.map((ev) => (
              <div
                key={ev._id}
                className="resource-box"
                style={{ padding: 0, overflow: "hidden", borderRadius: 14 }}
              >
                {/* Banner */}
                {/* Banner */}
                <div
                  style={{
                    width: "100%",
                    height: 180,
                    overflow: "hidden",
                    background: "#f3f4f6",
                    flexShrink: 0,
                    position: "relative",
                  }}
                >
                  {ev.imageUrl ? (
                    <img
                      src={ev.imageUrl}
                      alt={ev.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        background:
                          "linear-gradient(135deg, #0f2240 0%, #1a3a6b 60%, #3a9eaf 100%)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 44,
                        color: "#fff",
                      }}
                    >
                      📅
                    </div>
                  )}

                  {/* Overlay */}
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      background:
                        "linear-gradient(to top, rgba(0,0,0,0.45), rgba(0,0,0,0.05))",
                    }}
                  />
                </div>
                {/* Content */}
                <div style={{ padding: "16px 18px 18px" }}>
                  {ev.type && (
                    <span
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        background: "#dbeafe",
                        color: "#1d4ed8",
                        borderRadius: 999,
                        padding: "3px 10px",
                        display: "inline-block",
                        marginBottom: 8,
                      }}
                    >
                      {ev.type}
                    </span>
                  )}
                  <h4
                    style={{
                      margin: "0 0 10px",
                      fontSize: 15,
                      fontWeight: 700,
                      lineHeight: 1.4,
                    }}
                  >
                    {ev.title}
                  </h4>
                  <p
                    style={{
                      margin: "0 0 5px",
                      fontSize: 13,
                      color: "#6b7280",
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    🗓️{" "}
                    {new Date(ev.date).toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "short",
                      year: "numeric",
                    })}
                  </p>
                  {ev.location && (
                    <p
                      style={{
                        margin: 0,
                        fontSize: 13,
                        color: "#6b7280",
                        display: "flex",
                        alignItems: "center",
                        gap: 5,
                      }}
                    >
                      📍 {ev.location}
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ───────── CONTACT FORM ───────── */}
        <section style={{ background: "#0f2240", padding: "4rem 2.5rem" }}>
          <h2
            style={{
              color: "#fff",
              fontSize: "clamp(28px, 4vw, 42px)",
              fontWeight: 700,
              fontFamily: "Georgia, serif",
              lineHeight: 1.2,
              margin: "0 0 1rem",
            }}
          >
            Talk to an Expert Team Member
          </h2>
          <p
            style={{
              color: "rgba(255,255,255,0.6)",
              fontSize: 15,
              lineHeight: 1.7,
              margin: "0 0 2rem",
            }}
          >
            Receive a timely response to an enquiry about a service, process or
            technical questions.
            <br />
            Enter your details and the right person at Accelia will get in touch
            with you soon.
          </p>

          {submitted ? (
            <p
              style={{
                color: "#5dcaa5",
                background: "rgba(29,158,117,0.15)",
                border: "1px solid rgba(29,158,117,0.4)",
                borderRadius: 10,
                padding: "14px 18px",
                fontSize: 15,
                maxWidth: 700,
              }}
            >
              ✓ Message sent! We'll be in touch soon.
            </p>
          ) : (
            <form
              onSubmit={handleSubmit}
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 14,
                maxWidth: 700,
              }}
            >
              {[
                {
                  key: "name",
                  type: "text",
                  placeholder: "Full Name",
                  required: true,
                },
                {
                  key: "email",
                  type: "email",
                  placeholder: "Email Address",
                  required: true,
                },
                {
                  key: "phone",
                  type: "tel",
                  placeholder: "Phone Number",
                  required: false,
                },
              ].map(({ key, type, placeholder, required }) => (
                <input
                  key={key}
                  type={type}
                  placeholder={placeholder}
                  required={required}
                  value={formState[key]}
                  onChange={(e) =>
                    setFormState({ ...formState, [key]: e.target.value })
                  }
                  style={{
                    background: "rgba(255,255,255,0.07)",
                    border: "1px solid rgba(255,255,255,0.15)",
                    borderRadius: 10,
                    padding: "16px 18px",
                    fontSize: 15,
                    color: "#fff",
                    outline: "none",
                    width: "100%",
                    boxSizing: "border-box",
                    fontFamily: "inherit",
                  }}
                />
              ))}
              <textarea
                placeholder="Your Message"
                required
                value={formState.message}
                onChange={(e) =>
                  setFormState({ ...formState, message: e.target.value })
                }
                style={{
                  background: "rgba(255,255,255,0.07)",
                  border: "1px solid rgba(255,255,255,0.15)",
                  borderRadius: 10,
                  padding: "16px 18px",
                  fontSize: 15,
                  color: "#fff",
                  outline: "none",
                  width: "100%",
                  boxSizing: "border-box",
                  fontFamily: "inherit",
                  resize: "vertical",
                  height: 150,
                }}
              />
              <button
                type="submit"
                style={{
                  alignSelf: "flex-start",
                  background: "#3a9eaf",
                  color: "#fff",
                  border: "none",
                  borderRadius: 10,
                  padding: "16px 36px",
                  fontSize: 16,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Submit
              </button>
            </form>
          )}
        </section>
      </div>

      {/* ───────── PROFESSIONAL MODAL ───────── */}
      {modal && (
        <div
          onClick={() => setModal(null)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(10, 18, 40, 0.75)",
            backdropFilter: "blur(6px)",
            zIndex: 1000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
            animation: "fadeIn 0.2s ease",
          }}
        >
          <style>{`
            @keyframes fadeIn { from { opacity: 0 } to { opacity: 1 } }
            @keyframes slideUp { from { opacity: 0; transform: translateY(24px) scale(0.97) } to { opacity: 1; transform: translateY(0) scale(1) } }
            .modal-close-btn:hover { background: #f1f5f9 !important; color: #0f2240 !important; }
            .modal-read-btn:hover { background: #0e7490 !important; }
          `}</style>

          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#ffffff",
              borderRadius: 20,
              width: "100%",
              maxWidth: 640,
              maxHeight: "88vh",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              boxShadow:
                "0 32px 80px rgba(0,0,0,0.25), 0 0 0 1px rgba(255,255,255,0.08)",
              animation: "slideUp 0.28s cubic-bezier(0.34,1.4,0.64,1)",
            }}
          >
            {/* Modal Header */}
            <div
              style={{
                background: "linear-gradient(135deg, #0f2240 0%, #1a3a6b 100%)",
                padding: "28px 28px 24px",
                position: "relative",
                flexShrink: 0,
              }}
            >
              {/* Close button */}
              <button
                className="modal-close-btn"
                onClick={() => setModal(null)}
                style={{
                  position: "absolute",
                  top: 16,
                  right: 16,
                  width: 34,
                  height: 34,
                  borderRadius: "50%",
                  border: "none",
                  background: "rgba(255,255,255,0.12)",
                  color: "#fff",
                  fontSize: 16,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "background 0.15s, color 0.15s",
                  lineHeight: 1,
                }}
              >
                ✕
              </button>

              {/* Category badge */}
              {modal.category && (
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 5,
                    padding: "4px 12px",
                    borderRadius: 999,
                    fontSize: 12,
                    fontWeight: 700,
                    background: "rgba(255,255,255,0.15)",
                    color: "#fff",
                    marginBottom: 12,
                    letterSpacing: "0.04em",
                  }}
                >
                  🏷️ {modal.category}
                </span>
              )}

              {/* Title */}
              <h2
                style={{
                  color: "#ffffff",
                  fontSize: "clamp(18px, 3vw, 24px)",
                  fontWeight: 700,
                  fontFamily: "Georgia, serif",
                  lineHeight: 1.35,
                  margin: "0 40px 0 0",
                }}
              >
                {modal.title}
              </h2>

              {/* Meta row */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 16,
                  marginTop: 14,
                  flexWrap: "wrap",
                }}
              >
                {modal.date && (
                  <span
                    style={{
                      fontSize: 13,
                      color: "rgba(255,255,255,0.65)",
                      display: "flex",
                      alignItems: "center",
                      gap: 5,
                      fontWeight: 500,
                    }}
                  >
                    🗓️{" "}
                    {new Date(modal.date).toLocaleDateString("en-IN", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                )}
                {modal.tag && (
                  <span
                    style={{
                      fontSize: 12,
                      color: "rgba(255,255,255,0.55)",
                      display: "flex",
                      alignItems: "center",
                      gap: 4,
                      fontWeight: 500,
                    }}
                  >
                    # {modal.tag}
                  </span>
                )}
              </div>
            </div>

            {/* Divider accent */}
            <div
              style={{
                height: 3,
                background: "linear-gradient(90deg, #3a9eaf, #1d4ed8, #7c3aed)",
                flexShrink: 0,
              }}
            />

            {/* Modal Body */}
            <div
              style={{
                padding: "28px 28px 32px",
                overflowY: "auto",
                flex: 1,
              }}
            >
              <p
                style={{
                  fontSize: 15.5,
                  color: "#374151",
                  lineHeight: 1.8,
                  margin: 0,
                  whiteSpace: "pre-wrap",
                }}
              >
                {modal.content || modal.body || modal.description}
              </p>
            </div>

            {/* Modal Footer */}
            <div
              style={{
                borderTop: "1px solid #f0f0f6",
                padding: "16px 28px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexShrink: 0,
                background: "#fafafa",
                flexWrap: "wrap",
                gap: 10,
              }}
            >
              <span
                style={{
                  fontSize: 12.5,
                  color: "#9ca3af",
                  fontWeight: 500,
                }}
              >
                {modal.views ? `👁 ${modal.views} views` : "Accelia News"}
              </span>
              <button
                className="modal-close-btn"
                onClick={() => setModal(null)}
                style={{
                  background: "#0f2240",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "9px 22px",
                  fontSize: 13.5,
                  fontWeight: 600,
                  cursor: "pointer",
                  transition: "background 0.15s",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
